import { useEffect } from "react";

/**
 * NpfTracking — NoPaperForms "Dynamic Tracking" code.
 *
 * React equivalent of the vendor's inline snippet: sets the npf_d / npf_c / npf_m
 * globals and injects https://track.nopaperforms.com/js/track.js. The tracker
 * fires when this component mounts, i.e. on every navigation to a page that
 * renders it. The script is removed on unmount so it re-fires cleanly on the
 * next visit.
 *
 * Mounted on the pages that require NPF lead tracking (admission + contact).
 */
const NPF_TRACK_SRC = "https://track.nopaperforms.com/js/track.js";

const NpfTracking = () => {
  useEffect(() => {
    window.npf_d = "https://landing.ncet.co.in";
    window.npf_c = "6928";
    window.npf_m = "1";

    const s = document.createElement("script");
    s.type = "text/javascript";
    s.async = true;
    s.src = NPF_TRACK_SRC;
    s.dataset.npfTracking = "true";
    document.body.appendChild(s);

    return () => {
      if (s.parentNode) s.parentNode.removeChild(s);
    };
  }, []);

  return null;
};

export default NpfTracking;
